"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTrialBlock = setTrialBlock;
const taskStore_1 = require("../../../taskStore");
function compareTrialTypes(trialType1, trialType2) {
    return (trialType1 === trialType2 ||
        (trialType1.includes('match') && trialType2.includes('match')) ||
        (trialType1.includes('something-same') && trialType2.includes('something-same')));
}
function getBlockOperations(trialType) {
    if (trialType.includes('match')) {
        return 'updateMatching';
    }
    else if (trialType.includes('something-same')) {
        return 'updateSomethingSame';
    }
    else {
        return 'updateTestDimensions';
    }
}
function setTrialBlock(cat) {
    // create list of numbers of trials per block
    const blockCountList = [];
    const blockOperations = [];
    let currentTrialType = 'test-dimensions';
    let currentBlockCount = 0;
    if (cat) {
        (0, taskStore_1.taskStore)().corpora.stimulus.forEach((block) => {
            blockCountList.push(block.length);
        });
    }
    else {
        (0, taskStore_1.taskStore)().corpora.stimulus.forEach((trial) => {
            if (!compareTrialTypes(trial.trialType, currentTrialType) && trial.trialType !== 'instructions') {
                blockCountList.push(currentBlockCount);
                blockOperations.push(getBlockOperations(currentTrialType));
                currentTrialType = trial.trialType;
                currentBlockCount = 0;
            }
            currentBlockCount++;
        });
        blockCountList.push(currentBlockCount);
        blockOperations.push(getBlockOperations(currentTrialType));
    }
    return { blockCountList, blockOperations };
}
